<script lang="ts">
  import AutoComplete from '$shared/atoms/AutoComplete/AutoComplete.svelte';
  import { ListAlertType } from '../ListAlertProps';
  import AlertView from './AlertView.svelte';
  import Label from '$provider/constants/Label';
  import type { DataListAlert } from '$provider/models/datalist/DataListAlert';
  import { onMount } from 'svelte';

  interface Props {
    alert: DataListAlert;
    onevent?: (payload: { type: string; data: any }) => void;
  }

  let { alert, onevent }: Props = $props();

  let licenseTypeId: string | undefined;
  let licenseTypeLabel: string | undefined = $state();

  onMount(() => {
    licenseTypeId = alert?.props?.licenseTypeId;
    licenseTypeLabel =
      alert.props?.list?.find((item: any) => item.id === licenseTypeId)?.label || '';
  });

  const onClickLicenseType = (detail: CommonList): void => {
    licenseTypeId = detail.id;
    licenseTypeLabel = detail.label;
    onevent?.({
      type: 'change-licensetype',
      data: { key: alert.key, type: detail.id }
    });
  };

  const onLicenseTypeInputCleared = (): void => {
    if (!licenseTypeId) return;
    licenseTypeId = '';
    licenseTypeLabel = '';
    onevent?.({ type: 'clear-licensetype', data: { key: alert.key } });
  };
</script>

<AlertView
  type={ListAlertType.LicenseTypeChange}
  key={Label.ChangeTo}
  icon="icon-corner-down-right"
>
  {#snippet value()}
    <div class="licenseType">
      <AutoComplete
        name="licenseType"
        list={alert.props?.list || []}
        placeholder="Search Type"
        value={licenseTypeLabel}
        onclick={onClickLicenseType}
        oncleared={onLicenseTypeInputCleared}
      />
    </div>
  {/snippet}
</AlertView>

<style>
  .licenseType {
    width: 400px;
    padding: 4px 16px;
  }
</style>
